<template>
    <div class="doc-view">
      <DocContent :slug="slug" />
      <DocPagination :slug="slug" />
    </div>
  </template>
  
  <script>
  import DocContent from '../components/DocContent.vue'
  import DocPagination from '../components/DocPagination.vue'
  
  export default {
    name: 'DocView',
    components: {
      DocContent,
      DocPagination
    },
    props: {
      slug: {
        type: String,
        required: true
      }
    }
  }
  </script>